module.exports = __webpack_public_path__ + "img/flashmall4.7dedb6c9.jpeg";